
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiGround1Off as ObiGround1OffElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-ground-1-off.js';
 
 
 

 
 export const ObiGround1Off = createComponent({
   react: React,
   tagName: 'obi-ground-1-off',
   elementClass: ObiGround1OffElement,
   events: {
     
   }
  });
 
 